import { TextField } from '@superops/ui-design-system';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import {
  getTranslatedText,
  TEXT_LENGTH,
  Logo as ModuleLogo
} from '@nile/components';
import { useIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import envConfig from '@nile/home/src/Config/env';
import { cloneDeep, debounce } from 'lodash';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';

const ReportHeader = (props) => {
  const context = useContext(ReportsContext);
  const intl = useIntl();
  const { errors, isViewOnly, activeView } = props;

  const { name: nameVal, description: descriptionVal } = activeView;

  const [name, setName] = useState(nameVal || '');
  const [description, setDescription] = useState(descriptionVal || '');

  const handleChange = (prop, newValue) => {
    let updatedData = cloneDeep(context.activeReport);
    updatedData = {
      ...updatedData,
      [prop]: newValue
    };
    context.setActiveReport(updatedData);
  };

  const onSearch = (prop, val) => {
    handleChange(prop, val);
  };
  const setValue = useCallback(debounce(onSearch, 500), [context.activeReport]);

  useEffect(() => {
    setName(nameVal);
    setDescription(descriptionVal);
  }, [nameVal, descriptionVal]);

  return (
    <div className="fx f11 actr">
      <div>
        <ModuleLogo
          className="mr10"
          url={`${envConfig.imageRoot}svg/Reports.svg`}
        />
      </div>
      <div className="fx f11 fcol">
        <TextField
          placeholder={getTranslatedText(
            intl,
            'reports.report.title.placeholder'
          )}
          value={name}
          onChange={(val) => {
            setValue('name', val);
            setName(val);
          }}
          error={errors?.name?.[0]}
          fontSize="fontMedium"
          disabled={isViewOnly}
          maxLength={TEXT_LENGTH.size_5}
          autoFocus
          bgTransparent
          noborder
        />
        <TextField
          placeholder={getTranslatedText(
            intl,
            'reports.report.description.placeholder'
          )}
          value={description}
          onChange={(val) => {
            setValue('description', val);
            setDescription(val);
          }}
          error={errors?.description?.[0]}
          disabled={isViewOnly}
          maxLength={TEXT_LENGTH.size_9}
          bgTransparent
          noborder
        />
      </div>
    </div>
  );
};

export default withRouter(ReportHeader);
